import axios from 'axios'
import Fuse from 'fuse.js'
import swal from 'sweetalert2'
import showSwalAlert from 'src/util/alerts'
import { Alert, Badge, Button, Dialog, Tag, Table, TableColumn, Select, Option } from 'element-ui'
import {Pagination as LPagination} from 'src/components/index'
import XLSX from 'xlsx'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import alphabet from 'src/util/alphabet'

const mixinMasters = {
    components:{
        LPagination,
        [Alert.name]: Alert,
        [Badge.name]: Badge,
        [Button.name]: Button,
        [Dialog.name]: Dialog,
        [Select.name]: Select,
        [Option.name]: Option,
        [Tag.name]: Tag,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    data () {
        return {
            title: null,
            errorAlert: null,
            disabledField: false,
            rowData: null,
            selectClass: 'select-primary',
            searchQuery: '',
            tableData: [],
            filter_departments: [],
            filter_municipalities: [],
            fuseSearch: null,
            modals: {
                read: false,
            },
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            }
        }
    },
    computed: {
        pagedData () {
            return this.tableData.slice(this.from, this.to)
        },
        /***
         * Searches through table data and returns a paginated array.
         * Note that this should not be used for table with a lot of data as it might be slow!
         * Do the search and the pagination on the server and display the data retrieved from server instead.
         * @returns {computed.pagedData}
         */
        queriedData () {
            let result = this.tableData
            if (this.searchQuery !== '') {
                result = this.fuseSearch.search(this.searchQuery)
                this.pagination.total = result.length
            }
            return result.slice(this.from, this.to)
        },
        to () {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
                highBound = this.total
            }
            return highBound
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total () {
            this.pagination.total = this.tableData.length
            return this.tableData.length
        }
    },
    methods: {
        /**
        * este metodo se encarga de hacer la peticion a la api
        * para obtener todos los maestros registrados en el sistema
        * @return {Promise}
        */
        async getMasters(route) {
            return await axios.get( 'auth/'+route)
        },

        /**
        * este metodo se encarga de hacer la peticion a la api
        * para almacenar un modulo nuevo en la base de datos
        * @param  {JSON}
        * @return {Promise}
        */
        async saveMaster(data) {
            return await axios.post( 'auth/'+data.route, data)
        },

        /**
        * este metodo se encarga de hacer la peticion a la api
        * para actualizar un modulo existente en la base de datos
        * @param  {JSON}
        * @return {Promise}
        */
        async updateMaster(data) {
            return await axios.put( 'auth/'+data.route+'/'+data.id, data)
        },

        /**
        * este metodo se encarga de hacer la peticion a la api
        * para eliminar un modulo existente en la base de datos
        * @param  {JSON}
        * @return {Promise}
        */
        async destroyMaster(data) {
            if(data.logistic_center){
                return await axios.delete( 'auth/'+data.route+'/'+data.id+'?logistic_center='+data.logistic_center)
            }
            return await axios.delete( 'auth/'+data.route+'/'+data.id)
        },

        cleanSelect() {
            this.filter_municipalities = []
        },

        /**
        * este metodo se encarga de hacer la peticion a la api
        * para obtener el archivo en pdf con todos los maestros,
        * ademas crea un enlace y lo ejecuta para empezar la descarga
        * @return {VoidFunction}
        */
/*         exportPDF(data) {
            showSwalAlert(
                'Espere mientras el archivo en formato PDF se descarga.',
                null, true, null, null, null, swal
            )
            return axios({
                url: '/auth/'+data.route,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', data.name_file);
                document.body.appendChild(link);
                link.click();
                swal.close()
            });
        }, */

        /**
        * este metodo se encarga de hacer la peticion a la api
        * para obtener el archivo en excel con todos los maestros,
        * ademas crea un enlace y lo ejecuta para empezar la descarga
        * @return {VoidFunction}
        */
/*         exportExcel(data) {
            showSwalAlert(
                'Espere mientras el archivo en formato Excel se descarga.',
                null, true, null, null, null, swal
            )
            return axios({
                url: '/auth/'+data.route,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', data.name_file);
                document.body.appendChild(link);
                link.click();
                swal.close()
            });
        }, */
        modifyTable(type, id, response, modal=null, icon=null){
            let index = this.tableData.findIndex((tableRow) => tableRow.id === id);
            switch(type){
                case 0:
                    this.tableData.push(response.data.data)
                    this.closeModal('create')
                    this.$emit('cotentLoading', false)
                    this.$emit('showNotification', `<span>${response.data.message}</span>`, 'success', 'nc-simple-add')
                    break
                case 1:
                    this.$set(this.tableData, index, response.data.data)
                    this.closeModal('create')
                    this.$emit('cotentLoading', false)
                    this.$emit('showNotification', `<span>${response.data.message}</span>`, 'warning', 'nc-settings-tool-66')
                    break
                case 2:
                    if (index >= 0) this.tableData.splice(index, 1)
                    this.$emit('cotentLoading', false)
                    this.$emit('showNotification', `<span>${response.data.message}</span>`, 'danger', 'nc-simple-remove')
                    break
                case 3:
                    this.$set(this.tableData, index, response.data.data)
                    if(modal) this.closeModal(modal)
                    this.$emit('cotentLoading', false)
                    this.$emit('showNotification', `<span>${response.data.message}</span>`, 'warning', 'nc-settings-90')
                    break
                case 4:
                    if(modal) this.closeModal(modal)
                    this.$emit('cotentLoading', false)
                    this.$emit('showNotification', `<span>${response.data.message}</span>`, 'warning', icon)
                    break
            }
        },
        searchFuse(keys){
            this.fuseSearch = new Fuse(this.tableData, {threshold: 0.0, keys: keys})
            this.$emit('cotentLoading')
        },
        getError(fieldName){
            return this.errors.first(fieldName)
        },
        openModal (name) {
            this.modals[name] = true
        },
        closeModal(name){
            this.modals[name] = false
        },
/*         exportToPDF (route, name){
            let data = {}
            data.route = route
            data.name_file = name
            this.exportPDF(data).then(() => {
                this.showDownloadNotification()
            })
        },
        exportToExcel (route, name){
            let data = {}
            data.route = route
            data.name_file = name
            this.exportExcel(data).then(() => {
                this.showDownloadNotification()
            })
        }, */
        exportPDF(filename, title, page_format, data, table, plus=0) {

            let columns = []

            if (plus == 1) {
                let tablecol = table[0]
                tablecol = tablecol.concat(table[1])
                table = tablecol
            }

            table.forEach(row => columns.push({title: row.label, dataKey: row.prop}))

            showSwalAlert(
                'Espere mientras el archivo en formato PDF se descarga.',
                null, null, null, null, null, swal
            )

            setTimeout(() => {
                let doc = new jsPDF({orientation: "l", unit: "mm", format: page_format})
                doc.text(title, 10, 10);
                doc.autoTable(columns, data, {margin: {top: 20}, headStyles: {fillColor:'#FFA534'}})
                doc.save(filename, {returnPromise: true}).then((res) => {
                    swal.close()
                })
                this.showDownloadNotification()
            }, 1000);

        },
        exportExcel(filename, datatable, table, plus=0){

            showSwalAlert(
                'Espere mientras el archivo en formato XLSX se descarga.',
                null, null, null, null, null, swal
            )

            setTimeout(() => {

                if (plus == 1) {
                    let tablecol = table[0]
                    tablecol = tablecol.concat(table[1])
                    table = tablecol
                }

                let myHeader = table.map(prop => { return prop.prop })
                let myHeaderTrans = table.map(prop => { return prop.label })

                datatable.forEach( (elem) => {
                    for (const key in elem) {
                        if (!(myHeader.includes(key))) delete elem[key]
                    }
                })

                let data = XLSX.utils.json_to_sheet(datatable, { header: myHeader })

                for (let i = 0; i < myHeaderTrans.length; i++) {
                    data[alphabet[i]+'1'].v = myHeaderTrans[i];
                }

                const workbook = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(workbook, data, filename)

                new Promise((resolve, reject) => {
                    resolve(XLSX.writeFile(workbook, `${filename}.xlsx`))
                })
                    .then((res) => {
                        swal.close()
                        this.showDownloadNotification()
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }, 1000);
        },
        exportCSV(filename, tabledata, table, plus=0){

            showSwalAlert(
                'Espere mientras el archivo en formato CSV se descarga.',
                null, null, null, null, null, swal
            )

            setTimeout(() => {

                let datatable = JSON.parse(JSON.stringify(tabledata));

                if (plus == 1) {
                    let tablecol = table[0]
                    tablecol = tablecol.concat(table[1])
                    table = tablecol
                }

                let data = []

                datatable.forEach((elem) => {
                    let obj = {}

                    table.forEach((item) => obj[item.label] = elem[item.prop])

                    data.push(obj)
                })

                let csv = null

                new Promise((resolve, reject) => {
                    resolve(csv = this.$papa.unparse({'data': data}))
                })
                    .then((res) => {
                        swal.close()
                        this.$papa.download(csv, filename)
                        this.showDownloadNotification()
                    })
                    .catch((err) => {
                        console.log(err);
                    })

            }, 1000);
        },
/*
        exportPDFFront(data, columns, title, filename, formatS) {

            showSwalAlert(
                'Espere mientras el archivo en formato PDF se descarga.',
                null, null, null, null, null, swal
            )

            setTimeout(() => {
                let doc = new jsPDF({orientation: "l", unit: "mm", format: formatS})
                doc.text(title, 10, 10);
                doc.autoTable(columns, data, {margin: {top: 20}, headStyles: {fillColor:'#FFA534'}})
                doc.save(filename, {returnPromise: true}).then((res) => {
                    swal.close()
                })
            }, 1000);

        },

        exportExcelFront(datatable, myHeader, myHeaderTrans, filename){

            showSwalAlert(
                'Espere mientras el archivo en formato Excel se descarga.',
                null, null, null, null, null, swal
            )

            setTimeout(() => {

                datatable.forEach( (elem) => {
                    for (const key in elem) {
                        if (!(myHeader.includes(key))) delete elem[key]
                    }
                })

                let data = XLSX.utils.json_to_sheet(datatable, { header: myHeader })

                for (let i = 0; i < myHeaderTrans.length; i++) {
                    data[alphabet[i]+'1'].v = myHeaderTrans[i];
                }

                const workbook = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(workbook, data, filename)

                new Promise((resolve, reject) => {
                    resolve(XLSX.writeFile(workbook, `${filename}.xlsx`))
                }).then((res) => swal.close())

            }, 1000);
        },
 */
        showDownloadNotification(){
            this.$emit('showNotification', `<span> Archivo descargado correctamente </span>`, 'info', 'nc-cloud-download-93')
        },

        showMessageErrors(error, type) {
            console.log(error)
          this.$emit('cotentLoading')
          let msg = "";
          if (error.response && error.response.data && error.response.data.errors) {
            for (var key in error.response.data.errors) {
              msg += error.response.data.errors[key] + "<br/>";
            }
          } else {
            if (error.response.data && error.response.data.message) {
              msg = error.response.data.message;
            } else {
                if (type == 1) {
                    msg = 'La(s) Fila(s) Seleccionada(s) no registran anexos.';
                } else {
                    msg = 'Error al enviar la información, por favor revise los datos suministrados.';
                }
            }
          }

          showSwalAlert(msg, "error", false);
        },

        formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
          try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

            const negativeSign = amount < 0 ? "-" : "";

            let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;

            return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
          } catch (e) {
            console.log(e)
          }
        }
    },
 }

export default mixinMasters
